import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const importBatchAdjustments = (batchAdjustments, periodName) => fetch(
  Config.endpoints.IMPORT_BATCH_ADJUSTMENTS,
  {
    method: 'POST',
    body: JSON.stringify({ batchAdjustments, periodName }),
  }
)
  .then(handleErrors({ errorMessage: 'Importing batch adjustments failed' }));

export const validateBatchAdjustments = async (batchAdjustments, periodName) => await fetch(
  Config.endpoints.VALIDATE_BATCH_ADJUSTMENTS,
  {
    method: 'POST',
    body: JSON.stringify({ batchAdjustments, periodName }),
  }
)
  .then(handleErrors({ errorMessage: 'Validating batch adjustments failed' }))
  .then(parseAsJson);
